<template>
    <div class="panel panel-default">
        <div class="panel-body">
            <div class="row">
                <form class="form-inline" id="bs_form">
                    <!--关键字-->
					<div class="form-group" style="margin-top: 2px;">
							<input type="text" v-model="query.sttgWord" style="width: 200px;" v-validate="{required:true,max:50}" name="sttgWord" class="form-control" placeholder="题干关键字">
					</div>
                    <!--课程-->
					<div class="form-group" style="margin-left: 5px;margin-top: 2px;width: 200px;">
						<BootstrapCombobox :data="tkkcList"  data-vv-as="课程" name="kcId"  text-field="kcmc" value-field="id" v-model="query.kcId" :format-option="(item)=>(item.kcdm+'-'+item.kcmc)" placeholder="-课程筛选-"></BootstrapCombobox>
					</div>
                    <!--所属题库-->
					<div class="form-group" style="margin-left: 5px;margin-top: 2px;">
						<select name="sstk" v-model="query.tkId" class="form-control" style="width: 200px;">
							<option value="">-所属题库-</option>
							<option v-for="sstk in sstkList" :key="sstk.id" :value="sstk.id">{{sstk.tkmc}}</option>
						</select>
					</div>
                    <!--试题类别 -->
					<div class="form-group" style="margin-left: 5px;margin-top: 2px;">
						<select name="stlb" v-model="query.stlb"  class="form-control" style="width: 200px;">
							<option value="">-试题类别-</option>
							<option v-for="stlb in stlbList" :key="stlb.value" :value="stlb.value">{{stlb.text}}</option>
						</select>
					</div>
                    <!--题型 -->
					<div class="form-group" style="margin-left: 5px;margin-top: 2px;">
							<select name="tx" v-model="query.tx"  class="form-control" style="width: 200px;">
								<option value="">-题型-</option>
								<option v-for="tx in txList" :key="tx.tx" :value="tx.tx">{{tx.tx}}</option>
							</select>
                    </div>
                    <!--试题难度 -->
					<div class="form-group" style="margin-left: 5px;margin-top: 2px;">
						<select name="stnd" v-model="query.stnd"   class="form-control" style="width: 200px;">
							<option value="">-试题难度-</option>
							<option v-for="stnd in stndList" :key="stnd.value" :value="stnd.value">{{stnd.text}}</option>
						</select>
					</div>
                    <!--试题状态 -->
					<div class="form-group" style="margin-left: 5px;margin-top: 2px;">
						<select name="stzt" v-model="query.zt" class="form-control" style="width: 200px;">
							<option value="">-试题状态-</option>
							<option v-for="stzt in stztList" :key="stzt.value" :value="stzt.value">{{stzt.text}}</option>
						</select>
					</div>
                    <!--试题检查 -->
					<div class="form-group" style="margin-left: 5px;margin-top: 2px;">
							<select name="stjc" v-model="query.stjc"  class="form-control" style="width: 200px;">
								<option value="">-试题检查-</option>
								<option v-for="stjc in stjcList" :key="stjc.value" :value="stjc.value">{{stjc.text}}</option>
							</select>
					</div>
                    <!--错误原因-->
					<div class="form-group" style="margin-left: 5px;margin-top: 2px;">
						<input type="text" v-model="query.cwyyWord" style="width: 200px;" name="tkmc" class="form-control" placeholder="错误原因">
					</div>
                    <!--按钮-->
					<div class="form-group" style="margin-left: 5px;margin-top: 2px;">
						<button   @click="search()" type="button" class="btn btn-primary btn-sm" style="margin-right:3px"><i class="fa fa-search" aria-hidden="true"></i>搜索</button>
						<button   @click="Pldel()" type="button" class="btn btn-primary btn-sm" style="margin-right:3px"><i class="fa fa-remove" aria-hidden="true"></i>批量删除</button>
						<button   @click="Plsetstate()" type="button" class="btn btn-primary btn-sm" style="margin-right:3px"><i class="fa fa-check-square-o" aria-hidden="true"></i>批量设置状态</button>
					</div>
                </form>
            </div>
            <div class="row">
                <div class="col-sm-12" style="padding-top: 10px">
                    <BootstrapTable style="font-size: 14px;"
                                    ref="table"
                                    v-once
                                    :columns="columns"
                                    :options="{
										classes:'table table-hover',
                                    	undefinedText:'',
                                        showColumns: false,
                                        sidePagination:'server',
                                        pagination:true,
                                        pageNumber:1,
                                        pageSize:10,
                                        pageList:[10,50,100,500],
                                        paginationPreText:'上一页',
                                        paginationNextText:'下一页',
                                        showExtendedPagination:true,
                                        paginationLoop:false
                                    }"
                                    @onPostBody="vueFormatterPostBody"
                                    @onPageChange="pageChange"
									@onClickRow="clickRow"
                    />
                </div>
            </div>
        </div>

		<QuesBatchSetZt ref="QuesBatchSetZt"></QuesBatchSetZt>
		<QuesDetailDanXt ref="QuesDetailDanXt"></QuesDetailDanXt>
		<QuesDetailDuoXt ref="QuesDetailDuoXt"></QuesDetailDuoXt>
		<QuesDetailTianKt ref="QuesDetailTianKt"></QuesDetailTianKt>
		<QuesDetailTongYt ref="QuesDetailTongYt"></QuesDetailTongYt>
    </div>
</template>
<script>

    /**
     * 管理试题
     */

    import tableMixin from '@/mixins/table.js';  //表格
    import QuesBatchSetZt from './QuesBatchSetZt .vue';   //批量设置状态
    import QuesDetailDanXt from './QuesDetailDanXt.vue';//单选题
    import QuesDetailDuoXt from './QuesDetailDuoXt.vue';//多选题
    import QuesDetailTianKt from './QuesDetailTianKt.vue';//填空题
    import QuesDetailTongYt from './QuesDetailTongYt.vue';//其他题目使用同一个模板
    export default {
        mixins: [tableMixin],
        components: {
        	QuesBatchSetZt,
			QuesDetailDanXt,
			QuesDetailDuoXt,
			QuesDetailTianKt,
			QuesDetailTongYt
        },
        data:function(){
            return {
                js:this.$store.state.user.js,
                tkkcList:[],//课程下拉
                ssjgList:[],//所属机构
                sstkList:[],//题库
                stlbList:[],//试题类别
                txList:[],//题型
                stndList:[],//试题难度
                stztList:[],//试题状态
                stjcList:[],//试题检查
                query:{
                    sttgWord:'',
                    kcId:'',
                    ssjgId:'',
                    ssjg:'',
                    tkId:'',
                    stlb:'',
                    tx:'',
                    stnd:'',
                    zt:'',
                    stjc:'',
                    cwyyWord:'',
                },
                columns: [
                    {
                        field: 'state',
                        checkbox: true
                    },
                    {
                        title: '序号',
                        field: 'id',
                        align: 'center',
                        formatter: (value, row, index)=> {
                            var options = this.$refs.table.getOptions();
                            return options.pageSize * (options.pageNumber - 1) + index + 1;
                        }
                    },
                    {
                        field: 'kcmc',
                        title: '课程',
						formatter: (value, row)=> {
						  return row.kcdm+'-'+row.kcmc;
						}
                    },
                    {
                        field: 'jgmc',
                        title: '所属机构',
                        formatter: (value)=> {
                            return value || '公共';
                        }
                    },
                    {
                        field: 'tkmc',
                        title: '所属题库'
                    },
                    {
                        field: 'stlb',
                        title: '试题类别',
                        formatter: (value)=> {
                            return value=='SINGLECHOICE'?'单选题'
                                    :value=='MULTIPLECHOICE'?'多选题'
                                    :value=='JUDGMENT'?'判断题'
                                    :value=='BLANKFILL'?'填空题'
                                    :value=='ESSAY'?'问答题'
                                    :value=='MCJST'?'名词解释题'
                                    :value=='LST'?'论述题'
                                    :value=='JDT'?'简答题':'套题';
                        }
                    },
                    {
                        field: 'tx',
                        title: '题型'
                    },
                    {
                        field: 'zt',
                        title: '试题状态',
                        formatter: (value)=> {
                            return value=='OK'?'开放':'关闭';

                        }
                    },
                    {
                        field: 'cjyh',
                        title: '创建用户',
                        formatter: (value)=> {
                            return value || '';
                        }
                    },
                    {
                        field: 'cjsj',
                        title: '创建时间'
                    },
                    {
                        field: 'actions',
                        title: '操作',
                        align: 'center',
                        formatter: (value, row) => {
                            let html = "<div class='operation_column'>";
                            if(row.stlb=='TT'){
                                html+='<a @click="enter(row)">进入</a> | ';
                            }
                            return this.vueFormatter({
                                template :html+
                                			'<a @click="look(row)">查看</a> | '+
                                			'<a @click="edit(row)">修改</a> | '+
                                            '<a @click="del(row)">删除</a></div>',
                                data: { row },
                                methods: {
                                    enter: this.enter,
                                    sign: this.sign,
                                    look: this.look,
                                    edit: this.edit,
                                    del: this.del,
                                }
                            })
                        }
                    }
                ]
            }
        },
		mounted(){
			this.query = Object.assign(this.query,{current:1,size:10},this.$route.query);
			this.load();
		},
        beforeRouteUpdate(to, from, next){
			this.query = Object.assign(this.query,{current:1,size:10},to.query);
			this.load();
			next();
        },
        created:function(){
            this.gettkkcList();//课程下拉
            this.$store.commit('setBreadcrumb',[{name:'题库管理'},{name:'管理试题'}]);
            this.ssjgList = [{value: 'BJG', text: '本机构'}, {value: 'QTJG', text: '其他机构'}, {value: 'GG', text: '公共'}];//所属机构
            this.getsstkList();//题库
            this.stlbList = [{value: 'SINGLECHOICE', text: '单选题'}, {value: 'MULTIPLECHOICE', text: '多选题'}, {value: 'JUDGMENT', text: '判断题'}, {value: 'BLANKFILL', text: '填空题'}, {value: 'ESSAY', text: '问答题'}, {value: 'MCJST', text: '名词解释题'}, {value: 'LST', text: '论述题'}, {value: 'JDT', text: '简答题'}, {value: 'TT', text: '套题'}];//试题类别
            this.gettxkList();//题型
            this.stndList = [{value: 'FCRY', text: '非常容易'}, {value: 'BJRY', text: '比较容易'}, {value: 'CG', text: '常规'}, {value: 'JN', text: '较难'}, {value: 'FCN', text: '非常难'}];//试题难度
            this.stztList = [{value: 'OK', text: '开放'}, {value: 'BLOCK', text: '关闭'}];//试题状态
            this.stjcList = [{value: 'ZQST', text: '正确试题'}, {value: 'WJC', text: '未检查'}, {value: 'YSCT', text: '疑似错题'}];//试题检查

        },
        methods: {
            //课程下拉
            gettkkcList:function(){
                this.$http.post('/htgl/zktk/st/hqkc').then(res=>{
                    this.tkkcList = res.data;
                });
            },
            //题库下拉
            getsstkList:function(){
                this.$http.post('/htgl/zktk/st/hqtk').then(res=>{
                    this.sstkList = res.data;
                });
            },
            //题型下拉
            gettxkList:function(){
                this.$http.post('/htgl/zktk/st/hqtx').then(res=>{
                    this.txList = res.data;
                });
            },
            //进入
            enter:function(row){
                this.$router.push({name:'TaoTiList', query:{id:row.id}})
            },

            //标记(当试题检查为	疑似错题显示)
            sign:function(){
                    //操作提示confirm
					this.$confirm('确定要标记该试题为正确试题吗',()=>{

					})
            },

            //查看
            look:function(row){
                if(row.stlb=='SINGLECHOICE'){
					this.$refs.QuesDetailDanXt.open({  id:row.id,
                                stlb:row.stlb});
                }else if(row.stlb=='MULTIPLECHOICE'){
					this.$refs.QuesDetailDuoXt.open({  id:row.id,
					            stlb:row.stlb});
                }else if(row.stlb=='BLANKFILL'){
					this.$refs.QuesDetailTianKt.open({  id:row.id,
					            stlb:row.stlb});
                }else{
					this.$refs.QuesDetailTongYt.open({  id:row.id,
					            stlb:row.stlb});
                }
            },
            //修改
            edit:function(row){
                this.$router.push({name:'QuesEdit',query:{id:row.id}})
            },
            //批量删除
            Pldel:function () {
                let selections = this.$refs.table.getSelections();
                let ids = selections.map(x=>{return x.id});

                if(ids.length > 0){
                    ids = ids.join(",");
					this.$confirm('确定执行此操作吗',()=>{
						this.$http.post("/htgl/zktk/st/sc",{ids:ids}).then((res)=>{
						    if(res.data==true){
								this.$success('操作成功',()=>{
									this.search();//刷新列表
								})
						    }
						});
					})
                }
                else{
					this.$error('请选择一条数据记录');
                }
            },

            //删除
            del:function (row) {
                let ids = [];
                if(row){
                    ids.push(row.id);
                }
                else{
                    //批量删除
                    let selections = this.$refs.table.getSelections();
                    ids = selections.map(x=>{return x.id});
                }
                if(ids.length > 0){
                    ids = ids.join(",");
					this.$confirm('确定执行此操作吗',()=>{
						this.$http.post("/htgl/zktk/st/sc",{ids:ids}).then((res)=>{
						    if(res.data==true){
						        this.$success('操作成功',()=>{
									this.search();//刷新列表
								})
						    }
						});
					})
                }
                else{
					this.$error('请选择一条数据记录');
                }
            },
            //批量设置状态
            Plsetstate:function () {
                let selections = this.$refs.table.getSelections();
                let ids = selections.map(x=>{return x.id});
                if(ids.length > 0) {
                    ids = ids.join(",");
					this.$refs.QuesBatchSetZt.open({ ids:ids});
                }
            },
            search:function(){
                //将数据表格的页码以及每一页展示的数据重置为1，10
				let query = Object.assign(this.query,{current:1,size:10},{_t:new Date().getTime()});
				this.$router.push({name:this.$route.name,query:query});
            },

            //返回表格数据
            load:function(pageNumber, pageSize){
                this.query.current = pageNumber || this.query.current;
                this.query.size = pageSize || this.query.size;
                this.$http.post('/htgl/zktk/st/cx',this.query).then(res=>{
                    let data = res.data;
                    //封装返回值
                    let result= {
                        total: data.total,
                        rows: data.records
                    };
                    //table加载返回的数据
                    this.$refs.table.load(result);
					this.$refs.table.refreshOptions({pageNumber:parseInt(this.query.current),
						pageSize:parseInt(this.query.size)});
                });
            },
            pageChange:function(pageNumber, pageSize){
				let query = Object.assign(this.query,{current:pageNumber,size:pageSize},{_t:new Date().getTime()});
				this.$router.push({name:this.$route.name,query:query});
            }
        }

    }
</script>
<style scoped>

</style>
